import type { RoutePath, RouterState } from './router.model';

export function getCurrentRoute(state: RouterState): RoutePath {
  return state?.path;
}
